/** Loads Square's Web Payments SDK once, for the environment the server says it uses. */

export interface SquareSdk {
  payments: (appId: string, locationId: string) => {
    card: () => Promise<{
      attach: (selector: string) => Promise<void>;
      tokenize: () => Promise<{ status: string; token?: string; errors?: { message?: string }[] }>;
      destroy: () => Promise<void>;
    }>;
  };
}

declare global {
  interface Window {
    Square?: SquareSdk;
  }
}

let loading: Promise<SquareSdk> | null = null;

export function loadSquare(environment: 'sandbox' | 'production'): Promise<SquareSdk> {
  if (window.Square) return Promise.resolve(window.Square);
  if (loading) return loading;
  const src = environment === 'sandbox' ? 'https://sandbox.web.squarecdn.com/v1/square.js' : 'https://web.squarecdn.com/v1/square.js';
  loading = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.onload = () => (window.Square ? resolve(window.Square) : reject(new Error('Square SDK did not load')));
    script.onerror = () => {
      loading = null;
      reject(new Error('Square SDK failed to load'));
    };
    document.head.appendChild(script);
  });
  return loading;
}
